import { FormGroup, FormArray } from '@angular/forms';
import { isNullOrUndefined } from 'util';

export class FormControlHelpers {
  public static validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field: string) => {

      if (formGroup.controls[field] instanceof FormArray) {
        Object((formGroup.controls[field] as FormArray).controls).forEach((formArrayGroup: FormGroup, index: number) => {
          Object.keys(formArrayGroup.controls).forEach((formArrayGroupField: string) => {
            const formArrayControl = formArrayGroup.get(formArrayGroupField);
            if (!formArrayControl.disabled && !isNullOrUndefined(formArrayControl.errors)) {
              formArrayControl.markAsDirty();
              formArrayControl.markAsTouched();
            }

            if (formArrayControl instanceof FormGroup) {
              Object.keys(formArrayControl.controls).forEach((groupField: string) => {
                const groupControl = formArrayControl.get(groupField);
                if (!groupControl.disabled && !isNullOrUndefined(groupControl.errors)) {
                  groupControl.markAsDirty();
                  groupControl.markAsTouched();
                }
              });
            }
          });
        });
      }

      if (formGroup.controls[field] instanceof FormGroup) {
        Object.keys((formGroup.controls[field] as FormGroup).controls).forEach((groupField: string) => {
          const groupControl = (formGroup.controls[field] as FormGroup).get(groupField);
          if (!groupControl.disabled && !isNullOrUndefined(groupControl.errors)) {
            groupControl.markAsDirty();
            groupControl.markAsTouched();
          }
        });
      }

      const control = formGroup.get(field);
      if (!control.disabled && !isNullOrUndefined(control.errors)) {
        control.markAsDirty();
        control.markAsTouched();
        control.updateValueAndValidity();
      }
    });
  }

  public static disableAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field: string) => {

      if (formGroup.controls[field] instanceof FormGroup) {
        Object.keys((formGroup.controls[field] as FormGroup).controls).forEach((groupField: string) => {
          const groupControl = (formGroup.controls[field] as FormGroup).get(groupField);
          groupControl.disable();
        });
      }

      const control = formGroup.get(field);
      control.disable();
    });
  }

  public static resetAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field: string) => {
      const control = formGroup.get(field);
      control.setValue(null);
      control.markAsUntouched();
      control.markAsPristine();
      control.updateValueAndValidity();
    });
  }

  public static touchAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field: string) => {

      if (formGroup.controls[field] instanceof FormArray) {
        Object((formGroup.controls[field] as FormArray).controls).forEach((formArrayGroup: FormGroup, index: number) => {
          Object.keys(formArrayGroup.controls).forEach((formArrayGroupField: string) => {
            const formArrayControl = formArrayGroup.get(formArrayGroupField);
            if (!isNullOrUndefined(formArrayControl.value)) {
              formArrayControl.markAsDirty();
              formArrayControl.markAsTouched();
            }

            if (formArrayControl instanceof FormGroup) {
              Object.keys(formArrayControl.controls).forEach((groupField: string) => {
                const groupControl = formArrayControl.get(groupField);
                if (!isNullOrUndefined(groupControl.value)) {
                  groupControl.markAsDirty();
                  groupControl.markAsTouched();
                }
              });
            }
          });
        });
      }

      if (formGroup.controls[field] instanceof FormGroup) {
        Object.keys((formGroup.controls[field] as FormGroup).controls).forEach((groupField: string) => {
          const groupControl = (formGroup.controls[field] as FormGroup).get(groupField);
          if (!isNullOrUndefined(groupControl.value)) {
            groupControl.markAsDirty();
            groupControl.markAsTouched();
          }
        });
      }

      const control = formGroup.get(field);
      if (!isNullOrUndefined(control.value)) {
        control.markAsDirty();
        control.markAsTouched();
      }
    });
  }

  public static enableAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field: string) => {

      if (formGroup.controls[field] instanceof FormGroup) {
        Object.keys((formGroup.controls[field] as FormGroup).controls).forEach((groupField: string) => {
          const groupControl = (formGroup.controls[field] as FormGroup).get(groupField);
          if (!isNullOrUndefined(groupControl.value)) {
            groupControl.enable();
          }
        });
      }

      const control = formGroup.get(field);
      if (!isNullOrUndefined(control.value)) {
        control.enable();
      }
    });
  }
}
